// import apiService from '@/providers/apiService';
// import AppConstants from '@/appConstants';

export default {
  namespaced: true,
  state: {
    form: {}
  },
  getters: {},
  mutations: {
    SET_FORM(state, val) {
      state.form = val
    },
  },
  actions: {},
}
